import { buildService } from './index'

export default {
  ...buildService('commands')
}
